module.exports = __webpack_public_path__ + "img/ceo_caption.1a3f3d5d.jpg";